import(/* webpackMode: "eager" */ "/vercel/path0/app/[lang]/spraytest/page.js");
